/* Custom labels for native price experiment 8515e13a-0842-4e63-809a-feadfb94e97b.
 * Exact approved AUD50ml map; the new experiment duplicates the approved native
 * price table. This helper never changes native PDP, cart, or checkout prices.
 * Started only by the shared theme manager after native assignment is confirmed.
 */
function createAerreSpendPriceCopy(options) {
  'use strict';
  const { cohort, getState } = options;
  const rows = [["45060897767700",5500,5500],["45060897112340",4500,4900],["44755646054676",4900,4900],["45060893212948",3900,4500],["45060904419604",4500,4500],["45060924965140",5500,5500],["45060907893012",4900,5500],["51638719217940",5500,5500],["45060905107732",4900,5500],["50184500248852",4500,4900],["45060898652436",4500,4500],["54067060572436",4500,4900],["45060912972052",4900,5500],["45060909236500",4900,5500],["45060910874900",4500,4500],["49853092593940",4900,4900],["51639809900820",4500,5500],["45060922212628",5500,5500],["47158398648596",4500,5500],["51203417637140",4500,5500],["47519776538900",3900,4900],["50236470427924",4500,5500],["45060916773140",4500,4900],["51177372516628",3900,3900],["45060912218388",4500,4900],["47158733832468",4500,5500],["51203415834900",3900,4500],["48745471443220",3900,4500],["47158499836180",4500,4500],["51177530523924",4400,5500],["48401580622100",4500,5500],["48106383278356",3900,3900],["52518645530900",4900,4900],["47158271344916",4500,4900],["49063074595092",3500,3900],["50609588568340",4500,4900],["47869833249044",4500,5500],["50236454502676",5500,5500],["51203419242772",4200,4900],["51203420684564",4500,4900],["52567820828948",4500,4900],["54067965853972",4500,4500],["47158662824212",4900,5500],["47158772728084",4500,4900],["51992343871764",5500,5500],["47673648152852",3500,3500],["45060919787796",4900,5500],["48112332341524",2900,3500],["51203418685716",5500,5500],["50609719836948",4500,4900],["45060903567636",4900,4900],["51839360827668",3900,4900],["51839382225172",3900,4900],["47869680976148",4500,5500],["47966958190868",4500,4500],["47519050629396",3900,4900],["48391752188180",2900,2900],["45060925915412",5500,5500],["51203411575060",3300,3500],["50185405858068",4900,4900],["51839381209364",3500,3500],["51203418194196",4500,4500],["52654162477332",3900,3900],["50185524936980",4900,4900],["49853557604628",5500,5500],["52545557594388",3900,4500],["51177463939348",4400,4900],["51203423928596",5500,5500],["45060917264660",4500,4900],["50236440215828",5500,5500],["52519143637268",3900,4900],["48400189882644",4500,4500],["51177506308372",3900,3900],["51839259377940",4500,5500],["51839290278164",3900,3900],["51177313730836",3900,3900],["51203425435924",3900,3900],["52654090879252",4200,4500],["52453553438996",4500,4500],["45060923195668",4900,4900],["52141175210260",3500,3500],["51177418948884",4400,4500],["52453986599188",3900,4900],["49577008627988",4500,4500],["51203419078932",2900,2900],["50610086904084",4500,4900],["52651491295508",4900,4900],["49543806091540",4900,4900],["49853512286484",4500,4500],["51992438571284",5500,5500],["51177329066260",3900,3900],["47944737358100",5500,5500],["51177476849940",4200,4500],["49542556975380",4900,4900],["52545600684308",3900,3900],["52453036327188",3900,3900],["50236499853588",4500,4500],["51203416391956",3900,3900],["52141285966100",3900,3900],["51839447433492",5500,5500],["47646446420244",4500,4500],["52444931162388",4500,4900],["49853393666324",4500,4900],["49843708854548",4500,4500],["52651537727764",5500,5500],["49576922087700",5500,5500]];
  const prices = new Map(rows.map(row => [String(row[0]), row]));
  const ownedText = new Map();
  const events = ['aerre:threshold-state', 'variant:changed', 'change', 'shopify:section:load'];
  let active = cohort === 'low' || cohort === 'high';
  let frame = null;

  function moneyCents(text) {
    const match = String(text || '').match(/\$\s*([\d,]+(?:\.\d{1,2})?)/);
    return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : null;
  }

  function rowForForm(formId) {
    const form = document.getElementById(formId || '');
    return prices.get(String(form?.querySelector('[name="id"]')?.value || ''));
  }

  function rowForLabel(element) {
    const formId = element.getAttribute('data-aerre-price-form-id');
    return formId ? rowForForm(formId) : prices.get(String(element.getAttribute('data-aerre-price-variant-id') || ''));
  }

  function updateMoney(element, desired, allowed, seen) {
    if (!element || !Number.isSafeInteger(desired) || desired < 0) return;
    const walker = document.createTreeWalker(element, 4);
    let node;
    while ((node = walker.nextNode())) {
      const before = node.nodeValue;
      const observed = moneyCents(before);
      if (observed === null) continue;
      const saved = ownedText.get(node);
      // Do not overwrite a price from a different product, currency or offer.
      if (!allowed.includes(observed) && !(saved && before === saved.last)) return;
      seen.add(node);
      const after = before.replace(/(\$\s*)([\d,]+(?:\.\d{1,2})?)/, (_, prefix, amount) => {
        const decimals = amount.includes('.') || desired % 100 ? 2 : 0;
        return prefix + (desired / 100).toLocaleString('en-AU', {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
      });
      if (after !== before) {
        if (!saved || before !== saved.last) ownedText.set(node, {original: before, last: after});
        else saved.last = after;
        node.nodeValue = after;
      }
      return;
    }
  }

  function restoreUnused(seen) {
    for (const [node, saved] of ownedText) {
      if (seen.has(node)) continue;
      if (node.isConnected && node.nodeValue === saved.last) node.nodeValue = saved.original;
      ownedText.delete(node);
    }
  }

  function render() {
    if (!active) return;
    const seen = new Set();
    const state = typeof getState === 'function' ? getState() : null;
    if (state?.country === 'AU' && state?.currency === 'AUD') {
      document.querySelectorAll('[data-aerre-price-copy]').forEach(element => {
        const row = rowForLabel(element);
        if (!row) return;
        const price = row[cohort === 'high' ? 2 : 1];
        if (element.getAttribute('data-aerre-price-copy') === 'full') {
          updateMoney(element, price, [row[1], row[2]], seen);
        } else if (element.getAttribute('data-aerre-price-copy') === 'discounted') {
          const percent = Number(element.getAttribute('data-aerre-price-percent'));
          if (percent === 75 || percent === 70) {
            const discounted = cents => Math.round(cents * percent / 100);
            updateMoney(element, discounted(price), [discounted(row[1]), discounted(row[2])], seen);
          }
        } else if (element.getAttribute('data-aerre-price-copy') === 'inspiration-saving') {
          const retail = Number(element.getAttribute('data-aerre-price-retail-cents'));
          if (Number.isSafeInteger(retail) && retail > price) {
            updateMoney(element, retail - price, [retail - row[1], retail - row[2]], seen);
          }
        }
      });
      document.querySelectorAll('product-sticky-form[form-id]').forEach(sticky => {
        const row = rowForForm(sticky.getAttribute('form-id'));
        if (row) updateMoney(sticky.querySelector('.product-sticky-form__price'), row[cohort === 'high' ? 2 : 1], [row[1], row[2]], seen);
      });
      document.querySelectorAll('.aerre-bundle-selector__choice').forEach(choice => {
        const radio = choice.querySelector('input[type="radio"]');
        if (!radio || radio.getAttribute('data-bundle-option') !== null) return;
        const row = prices.get(String(radio.value || ''));
        if (row) updateMoney(choice.querySelector('.aerre-bundle-selector__pill > span:last-child'), row[cohort === 'high' ? 2 : 1], [row[1], row[2]], seen);
      });
    }
    restoreUnused(seen);
  }

  function schedule() {
    if (!active || frame !== null) return;
    frame = window.requestAnimationFrame(() => { frame = null; render(); });
  }

  const observer = new MutationObserver(schedule);
  if (active) {
    observer.observe(document.documentElement, {childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['value', 'data-aerre-price-variant-id']});
    events.forEach(name => document.documentElement.addEventListener(name, schedule));
    render();
  }

  function destroy() {
    active = false;
    observer.disconnect();
    if (frame !== null) window.cancelAnimationFrame(frame);
    frame = null;
    events.forEach(name => document.documentElement.removeEventListener(name, schedule));
    restoreUnused(new Set());
  }

  return {render, destroy};
}
